import BackGroundColor from "../CommanComponents/BackGroundColor";
import {
  X,
  CheckCircle2,
  XCircle,
  Volume2,
  HelpCircle,
  BarChart3,
  Award,
} from "lucide-react";
import { useState } from "react";

function ExtraDetailModel({ visable, Close, selectValue, title, part }) {
  const [isNight, setIsNight] = useState(false);

  if (!visable) return null;

  // Tıklanan buton ismine göre kategori tespiti
  const isTrueFalse = title?.toLowerCase().includes("true");
  const isListenFind = title?.toLowerCase().includes("listen");
  const isQuestionAnswer =
    title?.toLowerCase().includes("question") ||
    title?.toLowerCase().includes("answer");
  const isDescription = title?.toLowerCase().includes("description");

  // Gelen description dizisinden skoru güvenli bir şekilde çekme
  const descriptionScore =
    isDescription && selectValue?.[0]?.score ? selectValue[0].score : "0";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <BackGroundColor isNight={isNight} setIsNight={setIsNight} />

      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col z-50 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-500 to-amber-500 flex items-center justify-between p-5 text-white shadow-md">
          <div>
            <h3 className="text-xl font-bold tracking-wide">{title}</h3>
            <p className="text-xs opacity-90 font-medium mt-0.5">
              Sınıf: {part}
            </p>
          </div>
          <button
            onClick={Close}
            className="p-2 bg-white/20 text-white hover:bg-white hover:text-red-500 rounded-full transition-all duration-200 transform hover:scale-105"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* İçerik Alanı */}
        <div className="p-6 overflow-y-auto flex-1 bg-gray-50/50">
          {selectValue && selectValue.length > 0 ? (
            <div className="flex flex-col gap-4">
              {/* --- 1. DESCRIPTION (Sadece Yüzdelik/Skor Skalası) --- */}
              {isDescription && (
                <div className="flex flex-col items-center justify-center py-10 px-4 bg-white rounded-3xl shadow-sm border border-gray-100 text-center">
                  <div className="relative flex items-center justify-center mb-4">
                    <div className="w-32 h-32 rounded-full bg-purple-50 flex flex-col items-center justify-center border-4 border-purple-500 shadow-md animate-pulse">
                      <Award className="w-8 h-8 text-purple-600 mb-0.5" />
                      <span className="text-3xl font-black text-purple-700">
                        %{descriptionScore}
                      </span>
                    </div>
                  </div>
                  <h4 className="text-lg font-bold text-gray-800">
                    Genel Başarı Skoru
                  </h4>
                  <p className="text-sm text-gray-500 mt-1 max-w-xs">
                    Bu bölümdeki tanımlama etkinliklerinden kazandığınız toplam
                    başarı puanı.
                  </p>
                </div>
              )}

              {/* --- 2. TRUE & FALSE BÖLÜMÜ --- */}
              {isTrueFalse &&
                selectValue.map((item, index) => (
                  <div
                    key={item._id?.["$oid"] || index}
                    className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex flex-col gap-3"
                  >
                    <div className="flex justify-between items-center border-b border-gray-50 pb-2">
                      <span className="text-xs font-bold text-blue-600 bg-blue-50 px-2.5 py-1 rounded-lg">
                        Cümle {index + 1}
                      </span>
                      <span
                        className={`text-xs px-2.5 py-1 rounded-lg font-bold flex items-center gap-1 ${
                          item.status
                            ? "bg-green-50 text-green-700"
                            : "bg-red-50 text-red-700"
                        }`}
                      >
                        {item.status ? (
                          <CheckCircle2 className="w-3.5 h-3.5" />
                        ) : (
                          <XCircle className="w-3.5 h-3.5" />
                        )}
                        {item.status ? "Doğru Cevaplandı" : "Yanlış Cevaplandı"}
                      </span>
                    </div>

                    <p className="text-sm font-semibold text-gray-800 italic bg-gray-50/50 p-2.5 rounded-xl border border-gray-100/50">
                      "{item.sentence}"
                    </p>

                    <div className="grid grid-cols-2 gap-2 text-xs font-medium">
                      <div className="bg-gray-50 p-2 rounded-xl border border-gray-100">
                        <span className="text-gray-400 block mb-0.5">
                          Senin Tercihin:
                        </span>
                        <span
                          className={`font-bold ${item.givenAnswer ? "text-green-600" : "text-red-600"}`}
                        >
                          {item.givenAnswer ? "True (Doğru)" : "False (Yanlış)"}
                        </span>
                      </div>
                      <div className="bg-gray-50 p-2 rounded-xl border border-gray-100">
                        <span className="text-gray-400 block mb-0.5">
                          Doğru Mu?
                        </span>
                        <span className="font-bold text-purple-600">
                          {/* Status true ise tercih doğrudur, status false ise doğru cevap tercihin tersidir */}
                          {(item.status && item.givenAnswer) ||
                          (!item.status && !item.givenAnswer)
                            ? "Cümle Doğru"
                            : "Cümle Yanlış"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}

              {/* --- 3. LISTEN & FIND BÖLÜMÜ --- */}
              {isListenFind &&
                selectValue.map((item, index) => (
                  <div
                    key={item._id?.["$oid"] || index}
                    className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex flex-col gap-3"
                  >
                    <div className="flex justify-between items-center">
                      <span className="text-xs font-bold text-orange-600 bg-orange-50 px-2.5 py-1 rounded-lg flex items-center gap-1">
                        <Volume2 className="w-3.5 h-3.5" /> Ses / Görsel{" "}
                        {index + 1}
                      </span>
                      <span
                        className={`text-xs px-2.5 py-1 rounded-lg font-bold flex items-center gap-1 ${
                          item.status
                            ? "bg-green-50 text-green-700"
                            : "bg-red-50 text-red-700"
                        }`}
                      >
                        {item.status ? (
                          <CheckCircle2 className="w-3.5 h-3.5" />
                        ) : (
                          <XCircle className="w-3.5 h-3.5" />
                        )}
                        {item.status ? "Başarılı" : "Hatalı"}
                      </span>
                    </div>

                    <p className="text-sm font-semibold text-gray-800 italic">
                      Dinletilen Durum: "{item.sentence}"
                    </p>

                    <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-xs">
                      <span className="text-gray-400 block mb-1">
                        Senin İşaretleme Tercihin:
                      </span>
                      <span
                        className={`font-bold text-sm ${item.givenAnswer ? "text-blue-600" : "text-amber-600"}`}
                      >
                        {item.givenAnswer
                          ? "True (Doğru Resim/Buton)"
                          : "False (Yanlış Resim/Buton)"}
                      </span>
                    </div>
                  </div>
                ))}

              {/* --- 4. QUESTION & ANSWER BÖLÜMÜ --- */}
              {isQuestionAnswer &&
                selectValue.map((item, index) => (
                  <div
                    key={item._id?.["$oid"] || index}
                    className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex flex-col gap-3"
                  >
                    <div className="flex justify-between items-center">
                      <span className="text-xs font-bold text-purple-600 bg-purple-50 px-2.5 py-1 rounded-lg flex items-center gap-1">
                        <HelpCircle className="w-3.5 h-3.5" /> Soru {index + 1}
                      </span>
                      <span
                        className={`text-xs px-2.5 py-1 rounded-lg font-bold flex items-center gap-1 ${
                          item.status
                            ? "bg-green-50 text-green-700"
                            : "bg-red-50 text-red-700"
                        }`}
                      >
                        {item.status ? (
                          <CheckCircle2 className="w-3.5 h-3.5" />
                        ) : (
                          <XCircle className="w-3.5 h-3.5" />
                        )}
                        {item.status ? "Doğru" : "Yanlış"}
                      </span>
                    </div>

                    <div>
                      <span className="text-xs text-gray-400 block">Soru:</span>
                      <p className="text-sm font-bold text-gray-800">
                        {item.question}
                      </p>
                    </div>

                    <div className="flex flex-col gap-2 text-xs mt-1">
                      <div className="p-2.5 rounded-xl bg-gray-50 border border-gray-100">
                        <span className="text-gray-400 block mb-0.5">
                          Senin Verdiğin Cevap:
                        </span>
                        <p
                          className={`font-semibold text-sm ${item.status ? "text-green-600" : "text-red-600"}`}
                        >
                          {item.givenAnswer || "Cevap yazılmadı."}
                        </p>
                      </div>

                      {/* Kabul Edilen Alternatif Doğru Cevaplar Listesi */}
                      {item.answers && item.answers.length > 0 && (
                        <div className="p-2.5 rounded-xl bg-gray-50/50 border border-dashed border-gray-200">
                          <span className="text-gray-400 block mb-1.5">
                            Kabul Edilen Alternatif Doğru Cevaplar:
                          </span>
                          <div className="flex flex-wrap gap-1.5">
                            {item.answers.map((ans, aIdx) => (
                              <span
                                key={aIdx}
                                className="px-2 py-1 rounded-md text-[11px] bg-white text-gray-700 border border-gray-200 font-medium shadow-2xs"
                              >
                                ✓ {ans}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="text-center py-12 text-gray-400 flex flex-col items-center justify-center">
              <BarChart3 className="w-12 h-12 text-gray-300 mb-2 stroke-1" />
              <p className="text-sm font-medium">
                Bu kategoriye ait istatistik verisi bulunmuyor.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExtraDetailModel;
